export default __webpack_public_path__ + "static/screen_erp-4f9889e3f1bad347b95df8f2f6d36d58.png";